import * as React from 'react';

import Tooltip from 'components/mui/Tooltip';

import ErrorIcon from '@mui/icons-material/Error';

const RowMessages = React.memo(({ type, message }) => {
  return (
    <Tooltip t={message}>
      <ErrorIcon
        color={type}
        sx={{ fontSize: 18, position: 'absolute', zIndex: 10, right: 0, top: '50%', transform: 'translateY(-50%)' }}
      />
    </Tooltip>
  );
});

export default RowMessages;
